import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { BASE_URL } from '../config/api';
import { IMG_URL } from '../config/api';

const EditVP = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [vpData, setVpData] = useState({
        name: '',
        aname: '',
        image: '',
        amount: '',
        status: '',
    });

    const [imageFile, setImageFile] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        fetch(`${BASE_URL}vp/${id}`)
            .then(res => res.json())
            .then(data => {
                if (data.status === 1) {
                    setVpData(data.data);
                } else {
                    alert('Error fetching VP data');
                }
            })
            .catch(error => {
                console.error('Error fetching VP data:', error);
                alert('An error occurred while fetching VP data');
            });
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setVpData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        setImageFile(file);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);

        const formData = new FormData();
        formData.append('name', vpData.name);
        formData.append('aname', vpData.aname);
        formData.append('amount', vpData.amount);
        formData.append('status', vpData.status);

        // Only append image if a new one is selected
        if (imageFile) {
            formData.append('image', imageFile);
        } else {
            formData.append('image', vpData.image); // Send old image name
        }

        fetch(`${BASE_URL}vp/${id}`, {
            method: 'PUT',
            body: formData,
        })
            .then(res => res.json())
            .then(data => {
                setIsLoading(false);
                if (data.status === 1) {
                    alert('VP updated successfully');
                    navigate('/VPList');
                } else {
                    alert('Error updating VP');
                }
            })
            .catch(error => {
                setIsLoading(false);
                console.error('Error updating VP:', error);
                alert('An error occurred while updating the VP');
            });
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit VP</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Edit VP Details</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">Name</label>
                                        <input
                                            type="text"
                                            id="name"
                                            name="name"
                                            className="form-control"
                                            value={vpData.name}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="aname" className="form-label">Angadia Name</label>
                                        <input
                                            type="text"
                                            id="aname"
                                            name="aname"
                                            className="form-control"
                                            value={vpData.aname}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="amount" className="form-label">Amount</label>
                                        <input
                                            type="text"
                                            id="amount"
                                            name="amount"
                                            className="form-control"
                                            value={vpData.amount}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="status" className="form-label">Status</label>
                                        <select
                                            id="status"
                                            name="status"
                                            className="form-control"
                                            value={vpData.status}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="pending">Pending</option>
                                            <option value="completed">Completed</option>
                                        </select>
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="image" className="form-label">Image</label>
                                        <input
                                            type="file"
                                            id="image"
                                            className="form-control"
                                            onChange={handleImageChange}
                                        />
                                        {/* Show preview of existing image if no new image selected */}
                                        {vpData.image && !imageFile && (
                                            <div className="mt-3">
                                                <img
                                                    src={`${IMG_URL}images/${vpData.image}`}
                                                    alt="Current VP Image"
                                                    style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                                                />
                                            </div>
                                        )}
                                    </div>

                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary" disabled={isLoading}>
                                            {isLoading ? 'Updating...' : 'Update VP'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EditVP;
